import { SVGProps } from "react"

interface ScrollBarToolbarProps extends SVGProps<SVGSVGElement> {
  selectedColor?: string
}

const ScrollBarToolbar = ({ selectedColor, ...props }: ScrollBarToolbarProps) => (
  <svg
    width="36"
    height="41"
    viewBox="0 0 36 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 0.5H34C34.8284 0.5 35.5 1.17157 35.5 2V34C35.5 34.8284 34.8284 35.5 34 35.5H27H23.3907C22.682 35.5 22.0066 35.8008 21.5325 36.3276L18 40.2526L14.4675 36.3276C13.9934 35.8008 13.318 35.5 12.6093 35.5H9H2C1.17157 35.5 0.5 34.8284 0.5 34V2C0.5 1.17157 1.17157 0.5 2 0.5Z"
      fill={selectedColor || "white"}
      stroke="white"
    />
  </svg>
)
export default ScrollBarToolbar
